import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type TemplateCollectionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.TemplateCollectionsListFilterInput>
  sorts?: Types.InputMaybe<Types.TemplateCollectionsListSortInput>
  pagination?: Types.InputMaybe<Types.PaginationInput>
}>

export type TemplateCollectionsQuery = {
  __typename?: 'Query'
  templateCollections: {
    __typename?: 'TemplateCollectionsCollection'
    items: Array<{
      __typename?: 'TemplateCollection'
      uid: string
      title: string
      fieldNames: Array<string>
      templates?: Array<{
        __typename?: 'Template'
        description?: string | null
        tags?: Array<string> | null
        title: string
        uid: string
        fields: Array<{ __typename?: 'TemplateField'; name: string; text: any }>
      }> | null
    }>
  }
}

export const TemplateCollectionsDocument = gql`
  query TemplateCollections(
    $filters: TemplateCollectionsListFilterInput
    $sorts: TemplateCollectionsListSortInput
    $pagination: PaginationInput
  ) {
    templateCollections(filters: $filters, sorts: $sorts, pagination: $pagination) {
      items {
        uid
        title
        fieldNames
        templates {
          description
          fields {
            name
            text
          }
          tags
          title
          uid
        }
      }
    }
  }
`
export function useTemplateCollectionsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    TemplateCollectionsQuery,
    TemplateCollectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<TemplateCollectionsQuery, TemplateCollectionsQueryVariables>(
    TemplateCollectionsDocument,
    options
  )
}
export function useTemplateCollectionsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TemplateCollectionsQuery,
    TemplateCollectionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<TemplateCollectionsQuery, TemplateCollectionsQueryVariables>(
    TemplateCollectionsDocument,
    options
  )
}
export type TemplateCollectionsQueryHookResult = ReturnType<typeof useTemplateCollectionsQuery>
export type TemplateCollectionsLazyQueryHookResult = ReturnType<
  typeof useTemplateCollectionsLazyQuery
>
export type TemplateCollectionsQueryResult = ApolloReactCommon.QueryResult<
  TemplateCollectionsQuery,
  TemplateCollectionsQueryVariables
>
export function refetchTemplateCollectionsQuery(variables?: TemplateCollectionsQueryVariables) {
  return { query: TemplateCollectionsDocument, variables: variables }
}
